<template>
  <div class="ByallAuthorized">
    <el-table :data="listsTable" border style="width: 100%">
      <template slot="empty">
        <img class="data-pic" src="../../../../../assets/images/H5/null.png" alt>
        <br>暂无数据
      </template>
      <el-table-column prop="userRealName" label="授权方"></el-table-column>
      <el-table-column prop="mobile" label="手机号码"></el-table-column>
      <el-table-column prop="mail" label="邮箱"></el-table-column>
      <el-table-column prop="agentTime" label="授权时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span @click="isAuthorization(scope.row.id)">授权签章</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="fenYeBox">
      <el-pagination
        v-if="showPagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <auth-seal
      v-if="dialogVisibleTwo"
      :listImg="listImg"
      @close="dialogVisibleTwo=false"
      :userAgentId="currentUserAgentId"
    ></auth-seal>
    <Dialog
      :visible="dialogVisibleTwo"
      :dialogTitle="'被授权签章'"
      v-on:closeDialog="closeDialog('dialogVisibleTwo')"
      :width="'540px'"
      class="dialogVisibleTwoBox"
    >
      <div slot="dialog">
        <div class="accreditSq textAlign">
          <ul>
            <li v-for="item in listImg" :key="item.id">
              <img :src="item.fullFilePath" alt>
            </li>
            <li>
              <div>
                <img src alt>
                <div>点击添加</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import BaseApi from "@lib/baseApi.js";
import Dialog from "../../../../common/Dialog.vue";
import authSeal from "./authSeal.vue";
export default {
  data() {
    return {
      requestIng: false,
      listsTable: [],
      listImg: [],
      showPagination: false,
      dialogVisibleTwo: false,
      currentUserAgentId: "",
      idx: "",
      num: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var queryStres = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      BaseApi.createRpcToken("/agent/getAgentEmployer", queryStres)
        .then(
          data => {
            console.log(data);
            this.listsTable = data.datas.page.list;
            this.total = data.datas.totalRow;
            if (data.datas.totalRow > 10) {
              this.showPagination = true;
            } else {
              this.showPagination = false;
            }
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    isStart(id, num) {
      this.dialogStatus = true;
      this.idx = id;
      this.num = num;
    },
    closeDialog(flag) {
      this[flag] = false;
    },
    cancelFn(flag) {
      this[flag] = false;
    },
    isAuthorization(id) {
      this.currentUserAgentId = id;
      this.listImg = [];
      var params = { userAgentId: id };
      console.log(params);
      BaseApi.createRpcToken("/seal/authorizedSealList", params)
        .then(
          data => {
            console.log(data);
            if (data.datas != null) {
              this.listImg = data.datas.resultList;
            }
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
      this.dialogVisibleTwo = true;
    }
  },
  components: {
    BaseApi,
    Dialog,
    authSeal
  }
};
</script>
<style lang="scss">
.ByallAuthorized {
  width: 100%;
  th {
    padding: 0 10px;
    box-sizing: border-box;
    word-wrap: break-word;
    text-align: center;
  }
  .cell {
    padding: 0 10px;
    span {
      cursor: pointer;
    }
    span:hover {
      color: #db4437;
    }
  }
  th:nth-child(1),
  td:nth-child(1) {
    width: 13.2%;
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 19.8%;
  }
  th:nth-child(3),
  td:nth-child(3) {
    width: 22%;
  }
  th:nth-child(4),
  td:nth-child(4) {
    width: 10.2%;
  }
  th:nth-child(5),
  td:nth-child(5) {
    width: 16%;
  }
  .el-pagination {
    padding: 0;
    float: right;
  }
  table {
    table-layout: auto;
    tr {
      height: 32px;
      th {
        background: #f9f9f9;
      }
      td {
        text-align: center;
      }
    }
    thead {
      width: 100%;
      background: #f9f9f9;
      color: #505050;
      input {
        vertical-align: middle;
        width: 12px;
        height: 12px;
      }
    }
    tbody {
      tr {
        color: #969696;
        height: 48px;
        input {
          width: 12px;
          height: 12px;
        }
      }
    }
    .el-checkbox__inner:hover {
      border-color: #e88078;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #dcdfe6;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #e88078;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      border-color: #e88078;
      background: #e88078;
    }
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: #dcdfe6;
      background: #fff;
    }
  }
  .fenYeBox {
    margin-top: 20px;
  }
  .authorizationTrigger {
    margin-top: 22px;
    height: 32px;
    line-height: 32px;
    .el-checkbox {
      margin-left: 30px;
      margin-right: 11px;
    }
    div {
      input[type="checkbox"] {
        width: 12px;
        height: 12px;
        border: 1px solid #db4437;
        margin: 0 22px;
        vertical-align: middle;
      }
      .el-checkbox__inner:hover {
        border-color: #e88078;
      }
      .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #dcdfe6;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #e88078;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        border-color: #e88078;
        background: #e88078;
      }
      .authorTion {
        display: inline-block;
        width: 100px;
        height: 30px;
        border: 1px solid #db4437;
        color: #db4437;
        margin-left: 20px;
      }
      .authorTion:hover {
        background-color: #a5303d;
        color: #fff;
      }
    }
  }
  .dialogStatusBox {
    .header {
      height: 60px;
      line-height: 60px;
      .el-icon-close {
        top: 22px;
      }
    }
    .changeStatus {
      height: 200px;
      p:nth-child(1) {
        width: 100%;
        height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      p:last-child {
        text-align: center;
        span {
          display: inline-block;
          width: 100px;
          height: 32px;
          line-height: 32px;
          border: 1px solid #D81212;
          color: #db4437;
        }
        span:first-child {
          margin-right: 20px;
          color: #fff;
          background-color: #D81212;
        }
      }
    }
  }
  .dialogVisibleTwoBox {
    .header {
      height: 60px;
      line-height: 60px;
      .el-icon-close {
        top: 22px;
      }
    }
    .accreditSq {
      width: 100%;
      height: 316px;
      margin-left: 0;
      background: #ffffff;
      box-sizing: border-box;
      padding: 0 45px;
      padding-bottom: 20px;
      overflow-y: auto;
      ul {
        li {
          float: left;
          width: 113px;
          height: 113px;
          border: 1px solid #c8c8c8;
          margin-right: 44px !important;
          margin-top: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        li:nth-child(3n) {
          margin-right: 0 !important;
        }
      }
      .accreditList::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      .accreditList::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditList:hover::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditList::-webkit-scrollbar-thumb:hover {
        background-color: rgba(0, 0, 0, 0.4);
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditList::-webkit-scrollbar-track {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        background-color: white;
      }
      .accreditSq::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      .accreditSq::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditSq:hover::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditSq::-webkit-scrollbar-thumb:hover {
        background-color: rgba(0, 0, 0, 0.4);
        box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
      }
      .accreditSq::-webkit-scrollbar-track {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        background-color: white;
      }
    }
  }
}
</style>
